import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";
const qs = require("qs");

export async function fetchAdvise(params) {
  return await request({
    url: ENDPOINT.ADVISE,
    method: "get",
    params,
  });
}

export async function fetchAdviseById(id) {
  return await request({
    url: `${ENDPOINT.ADVISE}/${id}`,
    method: "get",
  });
}

export async function updateAdvise(id, data) {
  return await request({
    url: `${ENDPOINT.ADVISE}/update/${id}`,
    method: "post",
    data: qs.stringify(data),
  });
}

export async function deleteAdvise(id) {
  return await request({
    url: `${ENDPOINT.ADVISE}/delete/${id}`,
    method: "post",
  });
}
